import { instance } from "./axios";

export const updateSealingRoomMeasurement = (payload, id) => {
    try {
        return instance.put(`/visit/sealing/${id}`, payload);
    } catch (error) {
        throw error;
    }
};